export const userTypeListWithTranlations = (t) => ({
  REGULAR: t('LBLRegularContract'),
  LOCAL_ADMIN: t('LBLLocalAdminContract'),
  GLOBAL_ADMIN: t('LBLGlobalAdminContract'),
  AD_HOC: t('LBLAdHocContract')
});
